import React, { PropTypes } from 'react';
import Modal from 'components/UI/Modal';
import { alert } from 'util/alert';
import { confirm } from 'util/confirm';
import "./Modal.scss";
import ModalContent from "./ModalContent";
import { confirmable } from 'react-confirm';
import { Provider } from 'react-redux';
import store from 'root/store';
import locale from './locale';

import addMassLessonAndClass from 'controllers/lesson/addMassLessonAndClass';
import addStudentToMultiClass from 'controllers/class/addStudentToMultiClass';

class ModalBody extends React.Component {
  constructor(props){
    super(props);
    this.updateRequired = false;

    this.enrollClass = this.enrollClass.bind(this);
    this.onChange = this.onChange.bind(this);
    this.resultAlert = this.resultAlert.bind(this);
    this.nextStage = this.nextStage.bind(this);
    this.previousStage = this.previousStage.bind(this);
    
    this.state = {
      form: {},
      stage: 'enrollClass',
    };
  }

  static propTypes = {
    students: PropTypes.array.isRequired
  }

  onChange(value) {
    this.setState({
      form:{
        ...this.state.form,
        ...value,
      }
    });
  }

  enrollClass() {
    const {
      selectedClass,
      lessonIDSelected = [],
    } = this.state.form;

    const {
      students,
      proceed,
    } = this.props;

    confirm(__("Proceed to join '{className}'?", 'student', { className: selectedClass.className }), __('Join Class', 'student'))
      .then(()=>{
        const { classID } = selectedClass;

        const studentIDs = students.map((student)=>{
          return student.schoolStudentID;
        });

        this.setState({
          loading: true,
        });

        // 2 ways to to add onto a class. One through addMassLEssonAndClass
        // another through
        if (lessonIDSelected.length > 0) {
          addMassLessonAndClass(classID, {
            student_id_list: studentIDs,
            lesson_id_list: lessonIDSelected,
            conflict_tag: 1,
          })
            .then(({ data })=>{
              const { added_detail, conflicted_detail } = data;

              this.setState({
                loading: false,
              });

              this.resultAlert(students, conflicted_detail, added_detail);
            })
            .catch((err)=>{
              // TODO: create reverse function
              console.error(err);
            });
        } else {
          addStudentToMultiClass(classID, studentIDs)
            .then((res)=>{
              proceed({ updateRequired: true })
            })
            .catch((err)=>{
              // TODO: create reverse function
              console.error(err);
            });
        }
      })
      .catch((err)=>{
        console.error(err);
      });

  }

  resultAlert(students, conflicted_detail = [], added_detail = []) {
    const {
      dismiss,
      proceed,
    } = this.props;

    let namePerID = {}
    let conflictedStudentNames = [];
    students.map((student)=>{
      namePerID[student.schoolStudentID] = student.sName;
    });

    if (conflicted_detail.length > 0) {
      // FAILED
      let conflictedNames = '';
      conflicted_detail.map(({ conflicted_detail })=>{
        const { conflicted_student_list } = conflicted_detail.student;
        conflicted_student_list.map(({ student_id })=>{
          const studentName = namePerID[student_id];
          if (conflictedStudentNames.indexOf(studentName) === -1) {
            conflictedStudentNames.push(studentName);
          }
        });
      });
      conflictedNames = conflictedStudentNames.join(', ');

      alert.fail(
        <div>
          <p>{__('Failed to complete the request because following students have conflicted schedules:', locale)}</p>
          <p><b>{conflictedNames}</b></p>
        </div>, __('Failed To Complete Request', locale))
        .then(()=>{
          dismiss();
        });
    } else if (added_detail.length > 0) {
      // SUCCESS
      proceed({ updateRequired: true, });
    }

  }
  nextStage(){
    this.setState({
      stage: 'enrollLessons'
    })
  }
  previousStage(){
    this.setState({
      stage: 'enrollClass'
    })
  }
	render() {
		let {
      show,
      proceed,
      dismiss,
      cancel,
      students,
    } = this.props;

    const {
      loading,
      stage
    } = this.state;

    const {
      selectedClass,
    } = this.state.form;
    let footerButtons;
    if(stage === 'enrollClass'){
      footerButtons = []
    }else {
      footerButtons = [
        {
          title: __('Confirm', 'UI.confirm'),
          className: 'btn btn-primary pull-right',
          isDisabled: typeof selectedClass == 'undefined',
          onClick: ()=>{
            this.enrollClass();
          },
        }
      ]
    }
		return (
      <Modal
        isShowingModal={show} // if you want to show it when component mounts, set it true
        className='class-select-modal'
        // allowCloseByClickingShadow={false}
        // useDefaultClosebutton={true}
        onCloseModalClick={()=>{
          proceed({ updateRequired: this.updateRequired });
        }}
        // fixedHeight={300}
        fixedWidth={500}
        // overlayColor="#000"
        // contentHeight={300}

        loading={loading}

        hasHeader={true}
        headerType="bold" // default, bold
        headerTitle={__("Join Current Classes", "student")}
        headerIcon='fa icon-users' // class for icon tag
        // headerClassName=""
        // headerCustomContent={}
        hasFooter={true}
        footerButtons={footerButtons}
      >
        <Provider store={store}>
          <ModalContent 
            onChange={this.onChange} 
            nextStage={this.nextStage} 
            students={students} 
            stage={stage} 
            onPreviousStageSelect={this.previousStage}/>
        </Provider>
      </Modal>
    );
  }
}

export default confirmable(ModalBody);



// WEBPACK FOOTER //
// ./src/template/Modals/EnrollClass/ModalBody.js